import { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
import { useNavigate, Link } from "react-router-dom";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function handleLogin(e) {
  e.preventDefault();
  setError("");
  setLoading(true);
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    if (!userCredential.user.emailVerified) {
      navigate("/verify-email");
    } else {
      navigate("/");
    }
  } catch (err) {
    if (err.code === "auth/invalid-credential") {
      setError("Incorrect email or password.");
    } else {
      setError("Failed to log in. Please try again.");
    }
  }
  setLoading(false);
}

  return (
    <div className="min-h-screen flex" style={{ backgroundColor: "#0A0B0F" }}>
      {/* Left panel */}
      <div
        className="hidden lg:flex flex-col justify-between w-1/2 p-12 diagonal-cut"
        style={{ backgroundColor: "#C8FF00" }}
      >
        <div className="font-display text-4xl text-black tracking-wider">PREDICTORZ</div>
        <div>
          <div className="font-display text-8xl text-black leading-none mb-6">
            PREDICT.<br />COMPETE.<br />WIN.
          </div>
          <p className="font-condensed text-xl text-black/70 tracking-wide">
            The ultimate football prediction platform for you and your mates.
          </p>
        </div>
        <div className="font-condensed text-black/50 tracking-wide">World Cup 2026 · Premier League · Champions League</div>
      </div>

      {/* Right panel */}
      <div className="flex-1 flex items-center justify-center px-8">
        <div className="w-full max-w-md fade-up">
          <h1 className="font-display text-6xl text-white tracking-wider mb-2">WELCOME BACK</h1>
          <p className="font-condensed text-gray-400 text-xl tracking-wide mb-10">Log in to your account</p>

          {error && (
            <div className="mb-6 px-4 py-3 rounded-lg font-condensed tracking-wide text-red-400"
              style={{ backgroundColor: "#1A0A0A", border: "1px solid #3A1A1A" }}>
              {error}
            </div>
          )}

          <form onSubmit={handleLogin} className="space-y-5">
            <div>
              <label className="font-condensed text-gray-400 tracking-widest text-sm uppercase block mb-2">Email</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full rounded-xl px-4 py-3 text-white text-lg"
              />
            </div>
            <div>
              <label className="font-condensed text-gray-400 tracking-widest text-sm uppercase block mb-2">Password</label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full rounded-xl px-4 py-3 text-white text-lg"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="btn-lime w-full py-4 rounded-xl text-xl mt-2"
            >
              {loading ? "LOGGING IN..." : "LOG IN"}
            </button>
          </form>
<div className="mt-8 space-y-3 text-center">
  <p className="font-condensed text-gray-500 tracking-wide">
    <Link
      to="/forgot-password"
      className="hover:underline"
      style={{ color: "#FF5C00" }}
    >
      Forgot your password?
    </Link>
  </p>
  <p className="font-condensed text-gray-500 text-lg tracking-wide">
    Don't have an account?{" "}
    <Link to="/signup" className="hover:underline" style={{ color: "#C8FF00" }}>
      Sign up
    </Link>
  </p>
</div>
          
        </div>
      </div>
    </div>
  );
}